import React from 'react';
import './primitives.css';

export interface PageHeaderProps {
  readonly title: React.ReactNode;
  readonly eyebrow?: React.ReactNode;
  readonly subtitle?: React.ReactNode;
  readonly actions?: React.ReactNode;
  readonly className?: string;
  readonly 'data-testid'?: string;
}

/** SLDS-styled page header: eyebrow + title + subtitle on the left, actions right. */
export function PageHeader({
  title,
  eyebrow,
  subtitle,
  actions,
  className,
  ...rest
}: PageHeaderProps): React.ReactElement {
  return (
    <div className={['tl-pageheader', className ?? ''].filter(Boolean).join(' ')} {...rest}>
      <div>
        {eyebrow && <div className="tl-pageheader__eyebrow">{eyebrow}</div>}
        {typeof title === 'string' ? <h1 className="tl-pageheader__title">{title}</h1> : title}
        {subtitle && <p className="tl-pageheader__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="tl-pageheader__actions">{actions}</div>}
    </div>
  );
}
